export * from './usuario-agro-pendientes.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-pendientes/index.ts